module.exports = __webpack_public_path__ + "img/gadsden-state-logo.2d63f6f8.jpg";